import React,{useEffect} from "react";
import { useParams } from "react-router";



import DemoSchedule from "../../components/BookDemo/thankyouPage/DemoSchedule";
import SuccessMessage from "../../components/BookDemo/thankyouPage/SuccessMessage";
import { initGA, initGA2, initGtm } from "../../helpers/CampaignEvents";

const ThankYouPage = () => {
  const { component } = useParams();

  useEffect(() => {
    initGA2()
  }, [])
  return (
    <div className="bookdemo-root ">
      <div className="container">
        <div className="bookdemo">

          {component === "success" ? (
             <SuccessMessage />
          ) :(
            <DemoSchedule />

          )}
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
